import {
  FETCH_USERNAME_SUCCESS,
  CHECK_IF_LOGGED_IN_BEGIN,
  CHECK_IF_LOGGED_IN_SUCCESS,
  CHECK_IF_LOGGED_IN_FAILURE,
  CHECK_IF_CAN_ACCESS_STATS_BEGIN,
  CHECK_IF_CAN_ACCESS_STATS_SUCCESS,
  CHECK_IF_CAN_ACCESS_STATS_FAILURE,
} from '../../actions/auth';

const initialState = {
  hasLoadedIsLoggedIn: false,
  isLoggedIn: false,
  hasLoadedCanAccessStats: false,
  canAccessStats: false,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERNAME_SUCCESS:
      return {
        ...state,
        username: action.payload.data.username,
    };
    case CHECK_IF_LOGGED_IN_BEGIN: {
      return {
        ...state,
        hasLoadedIsLoggedIn: false,
        isLoggedIn: false,
      };
    }
    case CHECK_IF_LOGGED_IN_SUCCESS: {
      const { isLoggedIn } = action.payload.data;
      return {
        ...state,
        hasLoadedIsLoggedIn: true,
        isLoggedIn,
      };
    }
    case CHECK_IF_LOGGED_IN_FAILURE: {
      return {
        ...state,
        hasLoadedIsLoggedIn: true,
        isLoggedIn: false,
      };
    }
    case CHECK_IF_CAN_ACCESS_STATS_BEGIN: {
      return {
        ...state,
        hasLoadedCanAccessStats: false,
        canAccessStats: false,
      }
    }
    case CHECK_IF_CAN_ACCESS_STATS_SUCCESS: {
      const { canAccessStats } = action.payload.data;
      return {
        ...state,
        hasLoadedCanAccessStats: true,
        canAccessStats,
      }
    }
    case CHECK_IF_CAN_ACCESS_STATS_FAILURE: {
      return {
        ...state,
        hasLoadedCanAccessStats: true,
        canAccessStats: false,
      }
    }
    default:
      return state;
  }
}
